import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetTagListResponse = {
  TagId: string;
  TagName: string;
}[];

/**
 * 掲載商品グループ選択項目取得サービス
 * @export GetTagListService
 * @class GetTagListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTagListService extends PlessJsonResponderSub<GetTagListResponse> {
  model: KYMW4400Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(
    model: KYMW4400Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.succeed = s;
    this.fail = f;
    this.send('getTagList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: GetTagListResponse) {
    this.model.tagSelectItems = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW4400Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
